var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-3.27835e-07 8.5C-1.99945e-07 11.4258 2.28556 13.8186 5.16833 13.9902C5.58128 15.1732 6.7054 16 8 16C9.65714 16 11 14.6571 11 13L11 3C11 1.34286 9.65714 -4.22127e-07 8 -3.49691e-07C6.34286 -2.77255e-07 5 1.34286 5 3C5 3.00748 5.00003 3.01495 5.00008 3.02242C2.19714 3.27507 -4.53227e-07 5.63137 -3.27835e-07 8.5ZM1 8.5C1 6.0246 2.99982 4.01535 5.47163 4.00009C5.48509 4.00172 5.50093 4.00251 5.551 4.005C5.867 4.005 6.10376 3.71551 6.04106 3.40579C6.01389 3.27161 6 3.1359 6 3C6 1.89514 6.89514 1 8 1C9.10486 1 10 1.89514 10 3L10 13C10 14.1049 9.10486 15 8 15C7.04388 15 6.22655 14.3226 6.04017 13.3964C5.9932 13.1629 5.78812 12.995 5.55 12.995C5.50109 12.9975 5.48414 12.9984 5.47128 12.9999C2.99963 12.9845 1 10.9753 1 8.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCloud);
export default __webpack_public_path__ + "static/media/white_cloud.1fe42e01c0d7b99cdf49184d001c813c.svg";
export { ForwardRef as ReactComponent };